<template>
	<div class="content_box">
		<div class="title">
			<span class="left_shu"></span>
			视频回放
		</div>
		<div class="page_top_box">
			<div class="top_input_box">
				<el-date-picker v-model="today" type="date" placeholder="选择日期" @change="choiceTime"
					value-format='yyyyMMdd'>
				</el-date-picker>
			</div>
		</div>
		<div class="table_box">
			<el-table :data="pageList" style="width: 100%;">
				<el-table-column prop="name" label="通道名称" align='center'>
				</el-table-column>
				<el-table-column prop="startAt" label="开始时间" align='center'>
				</el-table-column>
				<el-table-column prop="duration" label="录像时长(秒)" align='center'>
				</el-table-column>
				<el-table-column fixed="right" label="操作" width="200" align='center'>
					<template slot-scope="scope">
						<el-button @click="show(scope.row)" type="text" size="small">播放</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div class="table_paging">
				<el-pagination @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize"
					:total="currentTotal" background layout="prev, pager, next">
				</el-pagination>
			</div>
		</div>
		<div class="model" v-if="modelShow">
			<div class="mask"></div>
			<div class="model-dialog">
				<div class="model-header">
					<span>{{title}}</span>
					<i class="el-icon-close" @click="hide"></i>
				</div>
				<div class="model-body" id="videoDiv">
					<video id="my-player" class="video-js" data-setup="{}" v-if="videoShow"></video>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import $ from "jquery"
	import videojs from "video.js";
	import axios from 'axios'
	export default {
		data() {
			return {
				modelShow: false, //添加编辑弹框控制
				title: '', //添加编辑弹框顶部文字
				tableData: [], //数据
				currentPage: 1, //页数
				pageSize: 10, //每页数量
				currentTotal: 0, //总数
				pageList: [],
				today: '',
				videoShow: false,
				myVideo: null
			}
		},
		mounted() {
			this.getData()
		},
		methods: {
			async getData() {
				var that = this
				axios.get('http://47.96.7.199:10000/api/v1/login', {
						params: {
							'username': 'admin',
							'password': '21232f297a57a5a743894a0e4a801fc3',
						}
					}).then(function(response) {
						that.Token = response.data.Token
					})
					.catch(function(error) {
						console.log(error);
					});
				var date = new Date();
				var year = date.getFullYear();
				var month = date.getMonth() + 1;
				var day = date.getDate();
				month = (month > 9) ? month : ("0" + month);
				day = (day < 10) ? ("0" + day) : day;
				this.today = year + month + day;
				console.log(date.getDate(0))
				that.getList()
			},
			getList() {
				var that = this
				axios.get('http://47.96.7.199:10000/api/v1/cloudrecord/querydaily', {
						params: {
							serial: '34020000001320000001',
							code: '34020000001320000001',
							Token: that.Token,
							period: that.today
						}
					}).then(function(response2) {
						that.tableData = response2.data.list.map(item => {
							var y = item.startAt.substr(0, 4)
							var z = item.startAt.substr(4, 2)
							var d = item.startAt.substr(6, 2)
							var h = item.startAt.substr(8, 2)
							var m = item.startAt.substr(10, 2)
							var s = item.startAt.substr(12, 2)
							return {
								...item,
								startAt: y + '-' + z + '-' + d + ' ' + h + ':' + m + ':' + s
							}
						})
						that.currentTotal = response2.data.list.length
						that.pageList = that.split_array(that.tableData, 10)[that.currentPage - 1]
						console.log('pageList', that.pageList)
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			split_array(arr, len) {
				var a_len = arr.length;
				var result = [];
				for (var i = 0; i < a_len; i += len) {
					result.push(arr.slice(i, i + len));
				}
				return result;
			},
			choiceTime(e) {
				this.getList()
			},
			show(e) {
				this.title = '视频播放'
				this.modelShow = true
				this.videoShow = true
				console.log('222222');
				$("#videoDiv").html('<video id="my-player" class="video-js" data-setup="{}">');
				console.log('1231231312');
				let options = {
					autoplay: true, // 设置自动播放
					controls: true, // 显示播放的控件
					language: "zh-CN",
					notSupportedMessage: "此视频暂无法播放，请稍后再试",
					sources: [
						//如果需要切换视频源，src需要动态设置
						{
							src: e.hls,
							type: "application/x-mpegURL", // 告诉videojs,这是一个m3u8流
						},
					],
				};
				setTimeout(() => {
					this.myVideo = videojs('my-player', options, function() {
						console.log('初始化完成...', this);
					});
				}, 300)
			},
			hide() {
				this.modelShow = false
				this.videoShow = false
				this.myVideo.dispose();
			},
			handleCurrentChange(val) {
				console.log(val)
				this.currentPage = val
				//点击下一页的时候 重新调用接口从后端取分页数据;{ current: this.currentPage } 为传给后端的字段
				this.getList()
			},
		}
	}
</script>

<style>
	.model-dialog {
		width: 1600px;
	}

	/* .video-js .vjs-progress-control .vjs-mouse-display {
		width: 30px !important;
	} */

	.video-js .vjs-time-tooltip {
		width: 50px !important;
	}

	.video-js {
		position: relative;
		width: 100%;
		height: 600px;
	}

	video {
		width: 100%;
		height: 100%;
	}
</style>
